import React from 'react'
// context
import GlobalSearchAPI from 'containers/GlobalSearch/layers/API'
// components
import GlobalSearch from '../../layouts/MainLayout/Drawer/components/GlobalSearch'

const GlobalSearchContainer = props => (
  <GlobalSearchAPI>
    <GlobalSearch {...props} />
  </GlobalSearchAPI>
)

export default GlobalSearchContainer
